import { Button, Flex, Grid, Text, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { KycStatusLayout, KycStepper } from '../../resources/components';
import { useKycData } from '../../resources/hooks/useKycData';
import { useLastFilledStep } from '../../resources/hooks/useLastFilledStep';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ hasHeader: true, hasDrawer: true });

    const company = useCompanyBasedOnUrl();
    const { isLoading } = useKycData();
    const { lastFilledStep } = useLastFilledStep();

    return (
        <KycStatusLayout
            stepper={<KycStepper direction='vertical' />}
            content={
                <>
                    <Helmet title={messages.pageTitle({ companyName: company?.displayName })} />

                    <Grid gap={16}>
                        <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                            {messages.title}
                        </Text>

                        <Text font='body' fontSize='medium' fontWeight='regular'>
                            {messages.fewMinutes}
                        </Text>

                        <Text font='body' fontSize='medium' fontWeight='regular'>
                            {messages.onceAppSubmitted}
                        </Text>

                        <Flex justifyContent='end'>
                            <Button
                                color='mint80'
                                disabled={isLoading}
                                as={Link}
                                to={getPath(Path.walletsKycWizard, company.id, lastFilledStep)}
                            >
                                {messages.continueOnboarding}
                            </Button>
                        </Flex>
                    </Grid>
                </>
            }
        />
    );
};

export default Page;
